import React from 'react';
import NFTMarketPlace from '../sectionBlocks/NFTMarket';
import Footer from "../sectionBlocks/Footer";
import {Helmet} from "react-helmet";

function PicturesMancavesAndBedrooms({data, loading, error, localData}) {
  return (
    <>
      <Helmet>
        <title>PopBelly NFT Pictures · Mancaves & Bedrooms</title>
      </Helmet>
      <div style={{minHeight: "200px"}}/>
      <NFTMarketPlace 
        displayCollectionName = {``} 
        collectionName = {`BedroOms and MaNCaVes NFT pictures PopBeLLy Collection`} 
        displayPagination = {``} 
        displayLink = {`dn`} 
        linkAddress = {``} 
        linkTitle = {``} 
        fetchingCardsRule = {({meta}) => (meta.content[1] === undefined && meta.attributes[0].value === "Mancave") || (meta.content[1] === undefined && meta.attributes[0].value === "Bedroom")}
        sliceStart = {0}
        loading = {loading} 
        error = {error} 
        data = {data} 
        localData = {localData}
      />
      <Footer/>
    </>
  );
}

export default PicturesMancavesAndBedrooms;
